import React, { Component } from "react";
import EditForm from "../forms/EditForm";
import axios from "axios";
import {
  Grid,
  Card,
  Message,
  Header,
  List,
  Icon,
  Button,
  Form,
  Checkbox,
  Divider,
  Table,
  Modal,
} from "semantic-ui-react";
// import { fetchPractitionerAgreements } from "../../actions/agreementActions";
import { connect } from "react-redux";
import { update } from "lodash";
const optionStyle = {
  marginTop: "-23px",
  marginLeft: "24px",
};
const styles = {
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  iconAndName: {
    display: "flex",
    alignItems: "center",
  },
  nameAndInfo: {
    display: "flex",
    flexDirection: "column",
  },
  info: {
    color: "rgba(0,0,0,.4)",
  },
};

class EditPage extends Component {
  state = {
    agreements: [],
    updated: false,
    isLoading: true,
    relations: [],
    practitionerLog: [],
  };

  submit = (data, agreements, loggedPractitioner) => {
    axios
      .post("/api/practitioners/updatePractitioner", {
        data,
        loggedPractitioner,
      })
      .then((resp) => {
        // console.log("updated");
        this.setState({
          updated: true,
        });
        setTimeout(() => {
          this.setState({
            updated: false,
          });
        }, 1000);
      });

    // axios
    //   .post('/api/practitioners/updatePractitionerAgreements', {
    //     practitioner_id: data.practitioner_id,
    //     remisiones: { accepted: data.remisiones, id: agreements.remisiones.id },
    //     donaciones: { accepted: data.donaciones, id: agreements.donaciones.id },
    //     boletin: { accepted: data.boletin, id: agreements.boletin.id }
    //   })
    //   .then(resp => {
    //     this.setState({
    //       updated: true
    //     });
    //     setTimeout(() => {
    //       this.setState({
    //         updated: false
    //       });
    //     }, 1000);
    //   });
  };

  handleDelete = (institucion_id) => {
    axios
      .delete(
        `/api/relations/deleteRelation/${this.props.username}/${institucion_id}`
      )
      .then((res) =>
        axios
          .get(`/api/relations/relationsByUser/${this.props.username}`)
          .then((res) => this.setState({ relations: res.data.resp }))
      );
  };
  componentDidMount() {
    axios
      .get(`/api/relations/relationsByUser/${this.props.username}`)
      .then((res) => this.setState({ relations: res.data.resp }));
    axios
      .get(`/api/practitioners/agreements/${this.props.practitioner_id}`)
      .then((resp) =>
        this.setState({
          agreements: resp.data.agreements,
          isLoading: false,
        })
      );
    axios
      .get(`/api/practitioners/practitionerLog/${this.props.practitioner_id}`)
      .then((res) => this.setState({ practitionerLog: res.data.resp }));
    // fetchPractitionerAgreements(this.props.id).then(data => {
    //   console.log(data);
    //   // this.setState({
    //   //   agreements: data.agreements,
    //   //   isLoading: false
    //   // });
    // });
  }

  _onChange = (e, data) => {
    const agreements = this.state.agreements.map((agreement) => {
      if (agreement.id === data._id) {
        agreement.accepted = data.checked === true ? 1 : 0;
      }
      return agreement;
    });
    // console.log(agreements);
    // updateUserAgreements({
    //   agreement_id: data._id,
    //   accepted: data.checked,
    //   agreement_name: data.name
    // })
    axios
      .post(`/api/practitioners/agreements/`, {
        id: this.props.practitioner_id,
        agreement_id: data._id,
        accepted: data.checked,
        agreement_name: data.name,
      })
      .then((message) => {
        this.setState({
          agreements: agreements,
          updated: true,
        });

        setTimeout(() => {
          this.setState({
            updated: false,
          });
        }, 500);
      });
  };
  createMarkup = (message) => {
    return { __html: message };
  };

  closeAlert = () => {
    this.setState({
      updated:false,
      successMessage:"",
      errorMessage:"",
    })
  }
  render() {
    const { updated, relations, practitionerLog } = this.state;
    const { role } = this.props;

    console.log(practitionerLog, "practitionerLog");
    let relationsItems = [];
    if (relations.length > 0) {
      relationsItems = relations.map((e, index) => (
        <List.Item key={index}>
          <List.Content verticalAlign="middle">
            <div style={styles.listItem}>
              <div style={styles.iconAndName}>
                <Icon size="big" color="teal" name="user md" />
                <div style={styles.nameAndInfo}>{e.nombre}</div>
              </div>
              {role ? (
                <div>
                  <Button
                    icon="trash"
                    color="red"
                    onClick={() => this.handleDelete(e.id)}
                  ></Button>
                </div>
              ) : null}
            </div>
          </List.Content>
        </List.Item>
      ));
    }

    let practitionerLogItems = [];
    if (practitionerLog.length > 0) {
      practitionerLogItems = practitionerLog.map((e, index) => (
        <Table.Row key={index}>
          <Table.Cell verticalAlign="middle">{e.last_modified_at}</Table.Cell>
          <Table.Cell verticalAlign="middle">{e.username}</Table.Cell>
          <Table.Cell verticalAlign="middle">
            {e.approvedStatus === 1 ? "Aprobado" : "No aprobado"}
          </Table.Cell>
        </Table.Row>
      ));
    }

    const _userAgreements = this.state.agreements.map((agreement) => {
      return (
        <Form.Field key={agreement.id}>
          <Checkbox
            _id={agreement.id}
            name={agreement.name}
            onChange={this._onChange}
            checked={agreement.accepted === 1 ? true : false}
          />
          <div
            style={optionStyle}
            dangerouslySetInnerHTML={this.createMarkup(agreement.short_message)}
          />
        </Form.Field>
      );
    });
    return (
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <Modal
              open={updated}
              onClose={this.closeAlert}
              size="small"
              centered            
            >
              <Modal.Header>Operación exitosa</Modal.Header>
                <Modal.Content>
                  <Header
                    size="medium"
                    textAlign="center"
                    color="blue"
                    >
                      Guardado {this.state.successMessage}
                  </Header>
                        </Modal.Content>
                        <Modal.Actions>
                          <Button color="blue" onClick={this.closeAlert}>
                              Aceptar
                          </Button>
                        </Modal.Actions>
                      </Modal>
          <Card fluid>
            <Message attached>
              <Header size="medium">Tratamiento de datos personales</Header>
            </Message>
            <Card.Content>
              {!this.state.isLoading && (
                <div>
                  <Header as="h2" style={{ margin: 0 }}>
                    Autorizaciones personales de manejo de datos.
                  </Header>
                  <p>
                    Sus autorizaciones de manejo de datos pueden ser modificadas
                    en cualquier momento. <br />
                    Si desea recibir información del{" "}
                    <strong>Grupo Empresarial Las Américas</strong>, lo
                    invitamos a presionar clic{" "}
                    <a
                      href="https://www.lasamericas.com.co/politica-de-tratamiento-de-datos-personales"
                      target="new"
                    >
                      <strong>aquí</strong>
                    </a>
                  </p>
                </div>
              )}
              <Divider hidden />
              <Form>{_userAgreements}</Form>
              {/* {this.state.updated && (
                <Message
                  success
                  content="Preferencia actualizada correctamente"
                />
              )} */}
            </Card.Content>
          </Card>
          <Card fluid={true}>
            <Message attached>
              <Header size="medium">
                Editar: {this.props.names + " " + this.props.lastnames}
              </Header>
            </Message>

            <Card.Content>
              <EditForm submit={this.submit} />
            </Card.Content>
          </Card>

          {relationsItems.length > 0 ? (
            <Card fluid>
              <Message attached>
                <Header size="medium">Instituciones asociadas</Header>
              </Message>
              <Card.Content>
                <List divided selection>
                  {relationsItems}
                </List>
              </Card.Content>
            </Card>
          ) : null}
          {practitionerLogItems.length > 0 ? (
            <Card fluid={true}>
              <Message attached>
                <Header size="medium">Historial de modificación</Header>
              </Message>

              <Card.Content>
                <Table celled>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Fecha y hora</Table.HeaderCell>
                      <Table.HeaderCell>Usuario</Table.HeaderCell>
                      <Table.HeaderCell>Estado</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>{practitionerLogItems}</Table.Body>
                </Table>
              </Card.Content>
            </Card>
          ) : null}
        </Grid.Column>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  const { names, lastnames, gender, username, practitioner_id } =
    state.practitionerInfo.resp;
  const { role } = state.practitioner.resp;
  return { names, lastnames, gender, username, practitioner_id, role };
};

export default connect(mapStateToProps, null)(EditPage);
